import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

/**
 * "Nothing to show" placeholder for a Reports tab.
 *
 * Distinct from ReportsErrorState: this one means the request succeeded and
 * genuinely returned no rows, so it must never be shown for a failed fetch.
 */
const ReportsEmptyState = ({ icon: Icon, title, message, iconSize = 64, padding = 6 }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: padding,
        textAlign: 'center'
      }}
    >
      <Icon sx={{ fontSize: iconSize, color: theme.palette.grey[400], mb: iconSize >= 64 ? 2 : 1 }} />
      <Typography variant="h6" color="text.primary" sx={{ mb: 1, fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default ReportsEmptyState;
